import Smartlook from 'smartlook-client';
import type { App } from 'vue';

interface SmartlookConfig {
  key: string;
  region?: 'eu' | 'us';
}

export function initSmartlook(config: SmartlookConfig): void {
  if (!config.key) {
    console.warn('Smartlook: Project key is missing. Session replay will not be initialized.');
    return;
  }

  try {
    Smartlook.init(config.key, {
      region: config.region || 'eu',
    });
  } catch (error) {
    console.error('Smartlook: Failed to initialize session replay:', error);
  }
}

export default {
  install(app: App, options: SmartlookConfig) {
    initSmartlook(options);
  },
};

export { Smartlook };
